import { GetterTree } from "vuex";
import { INomenclatureState } from "@/store/modules/nomenclature/state";
import { Nomenclature } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum NomenclatureGetters {
  GET_ALL = "GET_ALL_NOMENCLATURE",
  GET_CURRENT = "GET_CURRENT_NOMENCLATURE",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_NOMENCLATURE",
}

export const getters: GetterTree<INomenclatureState, IRootState> = {
  [NomenclatureGetters.GET_ALL](state): Nomenclature[] | null {
    return state.nomenclatures;
  },
  [NomenclatureGetters.GET_CURRENT](state): Nomenclature | null {
    return state.nomenclature;
  },
  [NomenclatureGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<Nomenclature> | null {
    return state.dataProvider;
  },
};
